<template>
  <div class="modal" :class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head is-block">
        <nav class="level">
          <div class="level-left">
            <div class="level-item">
              <p class="subtitle is-5">
                {{ title }}
              </p>
            </div>
          </div>
          <div class="level-right">
            <p class="level-item">
              <a
                class="button is-success"
                v-t="'Admin.save'"
                :disabled="!canSave"
                @click="$emit('save', inputValues)"
              ></a>
            </p>
            <p class="level-item">
              <a
                class="button is-outlined"
                v-t="'Admin.exit'"
                @click="$emit('update:show', false)"
              ></a>
            </p>
          </div>
        </nav>
      </header>
      <div class="modal-card-body">
        <div class="level">
          <div class="level-left">
            <div class="level-item">
              <div class="buttons">
                <span
                  class="button is-outlined"
                  :class="{ 'is-active': lang == selectedLanguage }"
                  v-for="lang in languages"
                  :key="lang"
                  @click="selectedLanguage = lang"
                  >{{ lang }}</span
                >
              </div>
            </div>
          </div>
          <div class="level-right">
            <div class="level-item">
              <div class="select">
                <select v-model="inputValues.status">
                  <option
                    disabled
                    selected
                    value=""
                    v-t="'Admin.status'"
                  ></option>
                  <option v-t="'Admin.enabled'" value="enabled"></option>
                  <option v-t="'Admin.disabled'" value="disabled"></option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-left" v-for="group in form.groups" :key="group.id">
          <h6 class="title is-6 is-uppercase">
            {{ $t(`Admin.Groups.${group.name}`) }}
          </h6>
          <div v-for="field in fieldsInGroup(group)" :key="field.id">
            <p>    {{ $t(`Admin.Sections.${field.name}`) }}</p>
            <!-- eslint-disable  vue/valid-v-model -->
            <component
              :is="componentToLoad(field.type)"
              class="is-fullwidth"
              v-if="inputValues[field.name]"
              :fieldProperties="field.properties"
              :parent="inputValues._id"
              :language="selectedLanguage"
              :canSave.sync="canSave"
              :value="inputValueForField(field)"
              @input="changeInputValues(field,$event)"
              vmodel="inputValues[field.name][selectedLanguageForField(field)]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pluck } from 'underscore'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    language: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    form: {
      type: Object,
      default: () => {}
    },
    values: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    FormText: () => import('@/components/FormText'),
    FormTextarea: () => import('@/components/FormTextarea'),
    FormFile: () => import('@/components/FormFile'),
    FormIcon: () => import('@/components/FormIcon'),
    FormSelect: () => import('@/components/FormSelect'),
    FormTag: () => import('@/components/FormTag'),
    FormRelational: () => import('@/components/FormRelational'),
    FormDependency: () => import('@/components/FormDependency'),
    FormColor: () => import('@/components/FormColor')
  },
  data () {
    return {
      languages: this.$store.state.availableLanguages,
      selectedLanguage: this.language,
      inputValues: {},
      capsules: [],
      canSave: true
    }
  },
  mounted () {
    const names = pluck(this.form.fields, 'name')
    names.forEach((name, index) => {
      if (this.form.fields[index].properties.multilingual) {
        this.$set(this.inputValues, name, {
          es: '',
          ca: '',
          en: '',
          default: ''
        })
      } else {
        if (name === 'status') {
          this.$set(this.inputValues, name, 'disabled')
        } else if (this.form.fields[index].type === 'relational' ||
        this.form.fields[index].type === 'dependency') {
          this.$set(this.inputValues, name, [])
        } else {
          this.$set(this.inputValues, name, {
            default: ''
          })
        }
      }
    })
    this.inputValues = { ...this.inputValues, ...this.values }
  },
  methods: {
    fieldsInGroup (group) {
      return this.form.fields.filter(field => field.group === group.id)
    },
    inputValueForField (field) {
      if (
        field.type === 'relational' ||
        field.type === 'dependency'
      ) {
        return this.inputValues[field.name]
      } else {
        return this.inputValues[field.name][this.selectedLanguageForField(field)]
      }
    },
    changeInputValues (field, value) {
      if (
        field.type === 'relational' ||
        field.type === 'dependency'
      ) {
        this.inputValues[field.name] = value
      } else {
        this.inputValues[field.name][this.selectedLanguageForField(field)] = value
      }
    },
    selectedLanguageForField: function (field) {
      if (field.properties.multilingual) {
        return this.selectedLanguage
      } else return 'default'
    },
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    componentToLoad: function (fieldType) {
      return 'Form' + this.capitalize(fieldType)
    }
  },
  filters: {
    visibleName: function (field) {
      if (field.properties.visibleName) {
        return (
          field.properties.visibleName[navigator.language.split('-')[0]] ||
          field.name
        )
      }
      return field.name
    }
  }
}
</script>

<style>
</style>
